// extracted by extract-css-chunks-webpack-plugin
module.exports = {"content":"content-2VFX2Hqk","lunbo":"lunbo-22NBOg_j","dotCurrent":"dotCurrent-2zXoAJRb","box":"box-1_8zkYSh","image":"image-1boQUQ_T","link":"link-2BD4tnZR"};